/**
 * Returns the path/URL string from an image import (string or module with src).
 */
export function toImagePath(img: { src?: string } | string): string {
  return typeof img === "string" ? img : img.src ?? "";
}
